<template>
    <div style="height:200px">
        <!-- <v-chart class="chart" :option="options" :autoresize="true" /> -->
        <div style="display:flex;">
            <div style="padding-left:15px;padding-top:20px">

                <p class="cishu">{{ zongshu }}<span>次</span></p>
                <p><img src="@/assets/bingtu.png"></p>

            </div>
            <div class="gjlist">
                <ul>
                    <li v-for="(item, index) in chatdata" :key="index" :class="'ys' + index"><span>{{
                            filters(item.warningType)
                    }} {{
        item.warningNum
}}次
                            <!-- {{ towNumber(item.warningNum
        / zongshu) * 100
}}% -->
                        </span></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from 'vue';
//import * as echarts from 'echarts';
export default defineComponent({
    name: 'GaoJing',
    components: {

    },
    props: { chatdata: Object },
    setup(props) {
        // const p = toRefs(props)

        let color = ['#6597FB', '#5FF5E8', '#18BEF7', '#F67C2D'];
        // let echartData = [
        //     {
        //         name: '系统故障',
        //         value: '3720',
        //     },
        //     {
        //         name: '系统告警',
        //         value: '2920',
        //     },
        //     {
        //         name: '电源告警',
        //         value: '2200',
        //     },
        //     {
        //         name: '电池告警',
        //         value: '1420',
        //     },
        // ];

        // let total = echartData.reduce((a, b) => {
        //     return a + b.value * 1;
        // }, 0);
        const options = ref({
            color: color,
            title: [
                {
                    text: '告警次数',
                    top: 'center',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 14,
                        rich: {
                            val: {
                                fontSize: 14,
                                fontWeight: 'bold',
                                color: '#FFF',
                            },
                        },
                    },
                },
            ],
            series: [
                {
                    type: 'pie',
                    radius: ['45%', '75%'],
                    center: ['50%', '50%'],
                    data: [],
                    hoverAnimation: false,
                    labelLine: {
                        normal: {
                            length: 10,
                            length2: 20,
                            lineStyle: {
                                color: 'rgba(75, 219, 198, 1)',
                            },
                        },
                    },
                    label: {
                        normal: {
                            formatter: (params) => {
                                return '{name|' + params.name + '}' + '\n' + ' {value|' + params.value + '次' + '}';
                            },
                            rich: {
                                name: {
                                    fontSize: 14,
                                    fontFamily: 'PingFang SC',
                                    fontWeight: 400,
                                    color: 'auto',
                                    lineHeight: 20,
                                    align: 'center'
                                },
                                value: {
                                    fontSize: 13,
                                    fontFamily: 'Source Han Sans CN',
                                    color: '#FFF',
                                    fontWeight: 400,
                                    lineHeight: 16,
                                    align: 'center'
                                },
                            },
                        },
                    },
                },
            ],
        });


        const zongshu = ref(0)

        watch(props, () => {
            let warningname = ''
            props.chatdata.some((item) => {
                zongshu.value += item.warningNum
                if (item.warningType === 'SYSTEM_FALT') {
                    warningname = '系统故障'
                } else if (item.warningType === 'SYSTEM_WARNING') {
                    warningname = '系统告警'
                } else if (item.warningType === 'BATTERY_WARNING') {
                    warningname = '电池告警'
                } else {
                    warningname = 'POWER_WARNING'
                }
                options.value.series[0].data.push({ name: warningname, value: item.warningNum })

            })
        }, {
            deep: true
        });
        function filters(id) {
            let txt = "";
            switch (id) {
                case 'SYSTEM_FALT':
                    txt = "系统故障";
                    break;
                case 'SYSTEM_WARNING':
                    txt = "系统告警";
                    break;
                case 'BATTERY_WARNING':
                    txt = "电池告警";
                    break;
                case 'POWER_WARNING':
                    txt = "电源告警";
                    break;
            }
            return txt;
        }
        onMounted(() => { //组件挂载时的生命周期执行的方法


        });

        return {

            options, zongshu, filters

        }
    }

})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cishu {
    color: #fff;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    font-family: Arial, Helvetica, sans-serif;
}

.cishu span {
    font-size: 18px;
}

.gjlist {
    color: #ccced3;
    margin-left: 30px;
    padding-top: 30px
}

.gjlist ul li {
    margin-bottom: 15px;
    list-style-type: disc;


}

.ys0 {
    content: ".";
    color: #3c8bfa
}

.ys1 {
    content: ".";
    color: #45e5cb
}

.ys2 {
    content: ".";
    color: #f5bd27
}

.ys3 {
    content: ".";
    color: #6a5df5
}

.gjlist ul li span {
    color: #ccced3;
}
</style>
